import { FlexContainer } from '@facephi/ui-react';
import styled from 'styled-components';

export const NoFilesUploadedStyles = styled(FlexContainer)`
  height: 100%;
  width: 100%;
`;
